import React from 'react';

export default function Pflicht() {
  return (
    <div className={'tw:mt-4'}>
      Bei &bdquo;*&ldquo; handelt es sich um Pflichtfelder.
    </div>
  );
}
